import { PropertyColor, PropertyColorsData } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const loadInlineStyles = (element: HTMLElement, styles: CSSResult) => {
  const styleTag = document.createElement('style');
  styleTag.setAttribute('type', 'text/css');
  element.appendChild(styleTag);
  const stringStyles = styles.toString();
  styleTag.appendChild(document.createTextNode(stringStyles));
};

export const propertyColorStyles = (
  callback: (
    propertyColor: PropertyColor,
    propertyAltColor: PropertyColor,
  ) => CSSResult,
) => {
  const styles: Array<CSSResult> = [];
  Object.entries(PropertyColorsData).forEach(
    ([propertyColor, propertyAltColor]) => {
      styles.push(
        callback(
          propertyColor as PropertyColor,
          propertyAltColor as PropertyColor,
        ),
      );
    },
  );

  return styles;
};
